<template>
  <div id="companySelect">
    <div class="tree_select" v-if="isReady">
      <!-- <el-popover popper-class="popClass" placement="bottom" width="auto" trigger="click" ref="selectPopover">
        <template #reference>
          <el-input id="inputHeader" :class="proper.visible ? '' : 'inputPlaceholder'" v-model="keyWord" style="width: 300px" :placeholder="placeholderText" @click="proper.visible = true" @blur="inputBlue">
            <template #suffix>
              <div>
                <el-icon class="icon" :style="proper.visible ? { transform: 'rotate(-180deg)' } : {}"><ArrowDown /></el-icon>
              </div>
            </template>
          </el-input>
        </template>
        <template #default>
          <el-scrollbar height="400px">
            <el-tree @node-click="
            " node-key="id" ref="tree" :data="comapnys" :current-node-key="subCompany.id" default-expand-all :props="{ children: 'itemList', label: 'label', disabled: 'disabled' }" :filter-node-method="filterNode">
              <template #default="scope">
                <div :id="'tree:' + scope.data.id" :style="scope.data.id == subCompany.id ? { color: '#409eff', fontWeight: 700 } : {}">
                  {{ scope.data.label }}
                </div>
              </template>
            </el-tree>
          </el-scrollbar>
        </template>
      </el-popover> -->
      <el-select v-model="comapnyId" filterable :placeholder="placeholderText" @change="changeCompany">
        <el-option v-for="item in comapnys" :key="item.companyId" :label="item.label" :value="item.companyId">{{ item.label }}</el-option>
      </el-select>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, Ref, watchPostEffect, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import commonApi from "../../api/common/commonApi";
import { useRoute, useRouter } from "vue-router";
import { ElTree, ElLoading, ElPopover } from "element-plus";
import { List } from "@/components/popoverSelect/limit";
import useInitData from "@/hooks/useInitData";
import useTabs from "@/hooks/useTabs";
import bus from "@/hooks/useBus";

const comapnyId = ref("");
const changeCompany = (id: string) => {
  const findItem = comapnys.value?.find((m: { companyId: string }) => m.companyId == id);
  selectCompany(findItem);
};
//监听兄弟组件layoutHeader发送的数据
bus.on("selectCompany", (data: any) => {
  selectCompany(data?.val, data.node, data.entryMode, data.data);
});
bus.on("getAllCompany", (data: any) => {
  GetAllCompany();
});
const placeholderText = computed(() => {
  let text = "";
  if (company.value?.companyName) {
    // text = company.value.companyName + "(" + company.value.companyNumber + ") - " + (subCompany.value.abbreviationName ? subCompany.value.abbreviationName : subCompany.value.subName);
    text = company.value?.companyName + "(" + company.value?.companyNumber + ")";
  }
  return text;
});
const { getCurrentToken } = useInitData();
const store = useStore();
const isReady = ref(false);
const proper = ref({ visible: false, keyWord: "" });
const keyWord = ref("");
const comapnys = ref();
//选择企业
const subCompany = ref({} as any);
const company = ref({} as any);
const route = useRoute();
const storeCompany = computed(() => store.getters.getThisCompany);
const selectPopover = ref<InstanceType<typeof ElPopover>>();
const approveCount = ref(0);
const badges = computed(() => store.getters.getBadges);
const editableTabs = computed(() => store.state.tag.tagList);
const tabNum = computed(() => store.getters.getTabNum);
const router = useRouter();
const tabs: Ref = ref(null);
const { retainName } = useTabs(editableTabs.value, tabs);

watchPostEffect(() => {
  const list = store.getters.getTagList;
  isReady.value = !!list.length;
  console.log(isReady.value, "isReadyisReadyisReadyisReadyisReady");
});
//顶部导航切换至工作台及审批中心时,判断原来选中的企业是否仍然存在于列表
//如果不存在则进行切换 切换至第一条
watch(tabNum, async (newData) => {
  if (newData == 2 || newData == 1) {
    await GetAllCompany(true);
    if (comapnys.value?.findIndex((m: { companyNumber: string }) => m.companyNumber == storeCompany.value.companyNumber) < 0) {
      selectCompany(comapnys.value[0]?.itemList[0], { isLeaf: true });
    }
  }
});
onMounted(() => {
  GetAllCompany();
});
const filterNode = (value: string, data: any) => {
  if (!value) return true;
  return data.label.includes(value);
};
const inputBlue = () => {
  proper.value.visible = false;
  setTimeout(() => {
    keyWord.value = "";
  }, 180);
};

const dataTransform = (oldData: any) => {
  oldData.forEach((element: { id: any; companyId: any; label: string; companyName: any; companyNumber: any; itemList: any[] }) => {
    element.id = element.companyId;
    element.label = `${element.companyName}(${element.companyNumber})`;
    if (element.itemList && element.itemList.length > 0) {
      element.itemList.forEach((item: { id: any; subid: any; label: any; abbreviationName: any; subName: any }) => {
        item.id = item.subid;
        item.label = item.abbreviationName ? item.abbreviationName : item.subName;
      });
    } else {
      element.itemList = [];
      element.itemList.push({ label: "暂无账套信息", disabled: true });
    }
  });
  return oldData;
};

const GetAllCompany = async (isreloadData?: boolean) => {
  //获取账套列表
  var UserInfo = store.getters.getUserinfo();
  var params = {
    agentId: UserInfo.agentId,
    userId: UserInfo.userid,
    phone: UserInfo.phone,
  };
  const { data } = await commonApi.GetAllSubCompanyList(params);
  //数据转换组装
  comapnys.value = dataTransform(data);
  if (isreloadData) {
    return;
  }
  store.dispatch("setTagList", comapnys.value);
  //取当前已选择的企业号
  const id = route.params.id as string;
  //已选择的企业号(id不为空时取id对应的企业号,否则取第一个)
  company.value = id ? comapnys.value?.filter((m: { companyNumber: string }) => m.companyNumber == id)[0] : comapnys.value[0];
  //设置默认选择的账套
  subCompany.value = company.value;
  // if (storeCompany.value && Object.keys(storeCompany.value).length > 0 && route.name != "manage" && String(route.name)?.indexOf("Customer") < 0) {
  //   subCompany.value = company.value?.itemList.find((m: { subid: string }) => m.subid == storeCompany.value.subid); //storeCompany.value;
  // }

  //将当前选择信息存入缓存
  await store.dispatch("setThisCompany", subCompany.value);
  GetapproveCount(company.value?.companyNumber);
  // if (subCompany.value) {
  //   selectCompany(subCompany.value, { isLeaf: true });
  // }
};
/**
 * val：要跳转的企业
 * node: 树节点
 * entryMode: 1:预算 2:审批 其他为树节点点击
 * data: route params
 */
const selectCompany = async (val: any, node?: any, entryMode?: number, data?: any) => {
  //判断点击节点时子级
  // if (node.isLeaf) {
  const loading = ElLoading.service({ fullscreen: true, text: "加载中" });
  //关闭poper
  proper.value.visible = false;
  selectPopover?.value?.hide();
  //设置当前选择的企业号
  company.value = comapnys.value?.find((m: { companyId: unknown }) => m.companyId == val.companyId);
  //设置当前选择的账套
  // subCompany.value = val;
  //组装数据
  const smallType = store.getters.getTagSmallType;
  var thisCompany = { ...subCompany.value, is_smallType: smallType > 9 ? 3 : 1, companyNumber: company.value?.companyNumber };
  //将当前选择信息存入缓存
  await store.dispatch("setThisCompany", thisCompany);
  GetapproveCount(company.value?.companyNumber);

  /**
   * entryMode=1 跳转至工作台预算页面
   * entryMode=2 跳转至审批中心
   * 否则刷新页面走到方法时当前页面或跳转时页面路由为以下情况时:
   * 包含manage 设置导航为系统管理
   * 包含customer 设置导航为客户管理
   */
  if (entryMode == 1) {
    //开始切换(获取token,记录页面标签等操作)
    await appointPage({ id: company.value?.companyNumber }, "budgetCloud");
  } else if (entryMode == 2) {
    await appointPage({ id: company.value?.companyNumber, approve: data.approve }, "approve");
  } else {
    if (route.path.indexOf("manage") > -1) {
      //系统管理
      store.dispatch("setCurrentTabNum", 2);
    } else if (route.path.toLocaleLowerCase().indexOf("customer") > -1) {
      //当前为客户管理
      store.dispatch("setCurrentTabNum", 4);
    } else {
      //开始切换(获取token,记录页面标签等操作)
      await loadPage(company.value?.companyNumber);
    }
  }
  loading.close();
  // } else {
  //   proper.value.visible = true;
  // }
};

const appointPage = async (data: any, name: string) => {
  if (!data.id) return;
  const o = editableTabs.value.find((item: List) => item.code == data.id);
  if (o && o.isDot) {
    o.isDot = false;
  }
  await getCurrentToken(data.id);
  if (name == "approve") {
    store.dispatch("setCurrentTabNum", 3);
  } else if (name == "manage") {
    store.dispatch("setCurrentTabNum", 2);
  } else {
    store.dispatch("setCurrentTabNum", 1);
  }
  retainName(data.id);
  router.push({ name, params: data });
  store.dispatch("setCurrentReloadIframe", true);
};
/**
 * 切换或刷新时重新获取token
 * 重新设置路由上携带的企业号
 */
const loadPage = async (id: string, isOne?: boolean) => {
  if (!id) return;
  await getCurrentToken(id);
  if (isOne) router.replace({ name: String(route.name), params: { id } });
  else router.push({ name: String(route.name), params: { id } });
  store.dispatch("setCurrentReloadIframe", true);
};
const GetapproveCount = (companyNumber: string) => {
  approveCount.value = badges.value?.find((m: { companyNumber: any }) => m.companyNumber == companyNumber)?.list.find((m: { moduleType: string }) => m.moduleType == "sp").count ?? 0;
};
</script>
<style lang="less">
.popClass {
  .el-tree {
    height: 450px;
    padding-right: 15px;
    // overflow: auto;
  }
}
</style>
